<template>
  <div class="part modals create-project-modal">
    <a-modal
      title="Create New Project"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="onCreate"
      @cancel="onCancel"
      okText="Create"
      :centered="true"
    >
      <a-form-model :model="project" ref="project" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <!-- Name -->
        <a-form-model-item label="Name/Last Name" prop="name">
          <a-input-group compact>
            <a-input v-model="project.name" style="width: 50%" placeholder="Name" required />
            <a-input v-model="project.last_name" style="width: 50%" placeholder="Last Name" />
          </a-input-group>
        </a-form-model-item>

        <!-- Organization -->
        <a-form-model-item label="Organization">
          <a-input v-model="project.organization" placeholder="Organization" />
        </a-form-model-item>

        <!-- Email -->
        <a-form-model-item label="Email">
          <a-input v-model="project.email" placeholder="Email" />
        </a-form-model-item>

        <!-- Phone -->
        <a-form-model-item label="Phone">
          <a-input-group compact>
            <a-input v-model="project.phone" style="width: 50%" placeholder="Number" />
            <a-input v-model="project.phone_extension" style="width: 50%" placeholder="Extension" />
          </a-input-group>
        </a-form-model-item>

        <!-- Secondary Phone -->
        <a-form-model-item label="Secondary Phone">
          <a-input-group compact>
            <a-input v-model="project.secondary_phone" style="width: 50%" placeholder="Secondary Phone" />
            <a-input v-model="project.secondary_phone_extension" style="width: 50%" placeholder="Extension" />
          </a-input-group>
        </a-form-model-item>

        <!-- Location -->
        <a-form-model-item label="Location">
          <a-input v-model="project.location" />
        </a-form-model-item>

        <!-- Address -->
        <a-form-model-item label="Address">
          <a-input v-model="project.address" />
        </a-form-model-item>

        <!-- Primary Language -->
        <a-form-model-item label="Primary Language">
          <a-input-group>
            <a-select v-model="project.locale" default-value="en-US" style="width: 100%">
              <a-select-option value="en-US"> English (U.S) </a-select-option>
              <a-select-option value="fr-FR"> French (France) </a-select-option>
              <a-select-option value="zh-CN"> 中文 (中国大陆) </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>

        <!-- Notification Methods -->
        <a-form-model-item label="Notification Methods">
          <a-input-group>
            <a-select
              v-model="project.notification_methods"
              mode="tags"
              default-value="email"
              style="width: 100%"
              placeholder="Notification Methods"
            >
              <a-select-option value="email"> Email </a-select-option>
              <a-select-option value="sms"> SMS </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>

        <!-- Source -->
        <a-form-model-item label="Source">
          <a-input-group>
            <a-select v-model="project.source" default-value="unknown" style="width: 100%">
              <a-select-option v-for="option in options_['GENERAL_SOURCES']" :key="option.key" :value="option.key">
                {{ option.value }}
              </a-select-option>
            </a-select>
          </a-input-group>
        </a-form-model-item>

        <!-- Note -->
        <a-form-model-item label="Note">
          <a-input v-model="project.note" type="textarea" :rows="4" />
        </a-form-model-item>

        <!-- Active -->
        <a-form-model-item label="Active" prop="active">
          <a-switch v-model="project.active" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import store from '@/store'

const KEY = 'CREATE_PROJECT'

export default {
  name: 'create-project-modal',
  data() {
    return {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      confirmLoading: false,
      project: {
        active: true,
      },
      rules: {
        name: [
          { required: true, message: 'Please input project name', trigger: 'blur' },
          { min: 1, max: 50, message: 'Length should be 1 to 50', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    visible: {
      get() {
        return this.$store.getters['crm/UI_VISIBLE'](KEY)
      },
      set(visible) {
        this.$store.dispatch('crm/UI_VISIBLE', { key: KEY, visible })
      },
    },
  },
  methods: {
    onCreate(e) {
      this.$refs.project.validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onCancel(e) {
      this.visible = false
    },
    onReset() {
      this.$refs.project.resetFields()
    },
  },
}
</script>

<style lang="scss" scoped></style>
